export enum Benutzertyp {
  ASSISTENT = "ASSISTENT",
  AUSSENDIENST = "AUSSENDIENST",
  AUTOTEST = "AUTOTEST",
  HOTLINE = "HOTLINE",
  INNENDIENST = "INNENDIENST",
  KONZERN_MITARBEITER = "KONZERN_MITARBEITER",
  MITBENUTZER = "MITBENUTZER",
  SERVICE_ACCOUNT = "SERVICE_ACCOUNT",
}

export const benutzerIdTypMap: Record<string, Benutzertyp> = {
  "1": Benutzertyp.AUSSENDIENST,
  "2": Benutzertyp.INNENDIENST,
  "3": Benutzertyp.MITBENUTZER,
  "6": Benutzertyp.KONZERN_MITARBEITER,
  "8": Benutzertyp.ASSISTENT,
  "9": Benutzertyp.SERVICE_ACCOUNT,
};
